/**
 * 水平填充
 */
import fvAnimation from './fvAnimation';

export default class fvHorFill extends fvAnimation {
    constructor (shape) {
        super(shape, 'fvHorFill');
        this.sizeFunction = AsyncFunction('return ' + this.expression);
        this.realMin = AsyncFunction('return ' + this.realMin);
        this.realMax = AsyncFunction('return ' + this.realMax);
        // 设置id
        this.HorfillDefsID = shape.uuid();
        // 获取背景色
        this.beforFill = shape.color;
        // 添加渐变标签
        this.horDefs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        document.getElementById('svgDom').appendChild(this.horDefs);
    }

    async run (domObject, value) {
        if (value == false) return;
        // 获取数据
        let size = await this.executionScript(this.sizeFunction);
        let realMinValue = await this.executionScript(this.realMin);
        let realMaxValue = await this.executionScript(this.realMax);
        if (size == -9999 || size == "__defaule" || size == undefined || isNaN(size)) {
            size = 0;
        }
        if (size >= realMaxValue) {
            size = realMaxValue;
        }
        if (size <= realMinValue) {
            size = realMinValue;
        }
        let viewNum = (parseFloat(this.viewMax) - parseFloat(this.viewMin)) * (size - parseFloat(realMinValue)) / (parseFloat(realMaxValue) - parseFloat(realMinValue)) + parseFloat(this.viewMin);
        // 判断参考点
        let x1 = 1;
        let x2 = 0;
        if (this.beginPath != 'right') {
            x1 = 0;
            x2 = 1;
        }
        this.horDefs.innerHTML = `<linearGradient id="${this.HorfillDefsID}" x1="${x1}" y1="0" x2="${x2}" y2="0">
                                        <stop offset="0%" style="stop-color:${this.fillcolor};stop-opacity:1" />
                                        <stop offset="${Math.abs(viewNum)}%" style="stop-color:${this.fillcolor};stop-opacity:1" />
                                        <stop offset="${Math.abs(viewNum) + 1}%" style="stop-color:${this.beforFill};stop-opacity:1" />
                                        <stop offset="${parseFloat(this.viewMax)}%" style="stop-color:${this.beforFill};stop-opacity:1" />
                                    </linearGradient>`;
        domObject.style.fill = `url(#${this.HorfillDefsID})`;
    }
}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvHorFill.js